import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function FooterSection() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-[#050505] border-t border-[#c9a84c]/20 py-16 mt-24" data-id="element-8">
      <div className="max-w-3xl mx-auto px-6 text-center flex flex-col items-center" data-id="element-9">
        <img src="https://cdn.magicpatterns.com/uploads/iW65h85ygjsqXA22bzjHSR/CBlogo_black_background.png" alt="Circle Barbershop Logo" className="max-w-[300px] w-full h-auto mb-8" data-id="element-10" />
        <div className="space-y-2 text-[#f5f0e8] text-lg font-['Source_Sans_3']" data-id="element-11">
          <p className="font-['Playfair_Display'] text-2xl text-white mb-4" data-id="element-12">
            {t.footer.tagline}
          </p>
          <p className="text-[#c9a84c] text-sm uppercase tracking-[0.3em] mb-2" data-id="element-13">
            Est. 1948
          </p>
          <a href="https://www.instagram.com/circlebarbershopvg" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:opacity-80 transition-opacity mb-4" data-id="element-14">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-15">
              <defs data-id="element-16">
                <radialGradient id="ig-grad-footer" cx="30%" cy="107%" r="150%" data-id="element-17">
                  <stop offset="0%" stopColor="#fdf497" data-id="element-18" />
                  <stop offset="5%" stopColor="#fdf497" data-id="element-19" />
                  <stop offset="45%" stopColor="#fd5949" data-id="element-20" />
                  <stop offset="60%" stopColor="#d6249f" data-id="element-21" />
                  <stop offset="90%" stopColor="#285AEB" data-id="element-22" />
                </radialGradient>
              </defs>
              <rect x="2" y="2" width="20" height="20" rx="5" stroke="url(#ig-grad-footer)" strokeWidth="2" data-id="element-23" />
              <circle cx="12" cy="12" r="5" stroke="url(#ig-grad-footer)" strokeWidth="2" data-id="element-24" />
              <circle cx="17.5" cy="6.5" r="1.5" fill="url(#ig-grad-footer)" data-id="element-25" />
            </svg>
            <span className="text-sm uppercase tracking-[0.2em] text-[#c9a84c]" data-id="element-26">
              @circlebarbershopvg
            </span>
          </a>
          <p data-id="element-27">3964 Curtiss Pkwy, Virginia Gardens, FL 33166</p>
          <p data-id="element-28">
            <a href="tel:3058853240" className="text-[#c9a84c] hover:text-white transition-colors text-xl font-bold" data-id="element-29">
              (305) 885-3240
            </a>
          </p>
        </div>
      </div>
    </footer>;
}